export const ethnicityChoices = [
    "Russian",
    "British",
    "Brazilian",
    "Chinese",
    "Korean",
    "Japanese",
    "Filipino",
    "Spanish",
    "Mexican",
    "Latina",
    "French",
    "Swedish",
    "Kazakh",
    "Jewish",
    "Arabic",
    "Armenian",
    "American",
    "Indian"
];

export const expressionChoices = [
    "Neutral",
    "Normal",
    "Sad"
];

export const compositionChoices = [
    '(full body)',
    'Portrait'
];

export const bodyTypeChoices = [
    "Average",
    "Skinny",
    "Fat"
];

export const femaleModelChoices = [
    "College Girl",
    "Supermodel",
    "Woman",
    'Athlete'
];

export const haircolorChoices = [
    "Blonde",
    "Brown",
    "Black",
    "Red",
    "Blue",
    "Green",
    "White",
    "Purple",
    "Rainbow",
    "Orange"
];

export const hairstyleChoices = [
    "Bangs",
    "Ponytail",
    "Straight hair",
    "Short hair",
    "Braids",
    "Long hair",
    'Pixie hairstyle',
    'Wild hairstyle'
];

export const placeChoices = [
    'Beach',
    'Pool',
    'Street',
    'Bedroom',
    'Desert',
    'Mountains',
    'Jungle',
    'Snow',
    'Church',
    'Farm',
    "Bathroom",
    "Woods",
    "Mall",
    "Airplane",
    "Car",
    'Bar',
    "Festival"
];

export const clothingsChoices = [
    "Bikini",
    'Jacket',
    "Blouse",
    'Tank Top',
    "Sports Bra",
    'Lingerie',
    "Robot Suit",
    "Dress",
    'Fur Coat',
    "Corset",
    "Military Jacket",
    "Bomber Jacket",
    "Pajamas",
    'Medieval Armor',
    'Kimono',
    "Superhero Outfit",
    'Hijab'
];

export const accessoriesChoices = [
    "Scarf",
    "Necklace",
    "Choker",
    "Earrings",
    "Tattoos",
    "Lipstick",
    "Sunglasses",
    "Surgical Mask",
    "Baseball Cap",
    "Beret",
    "Veil",
    "Headphones",
    "Headband",
    "Beanie",
    "Santa Hat",
    "Cowboy Hat",
    "Sunhat",
];

export const photostylesChoices = [
    "Selfie",
    "Polaroid"
];